import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Reveal } from "@/components/motion";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" }) : "";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .get("/posts")
      .then((res) => setPosts(res.data))
      .catch(() => setError(true));
  }, []);

  return (
    <>
      <Seo
        title="Blog — OSSD Guides for Students & Parents | EGOS"
        description="Practical guides on earning your Ontario Secondary School Diploma online — OUAC streams, PLAR credits, grading, university pathways and study planning."
        path="/blog"
      />
      <PageHero
        eyebrow="Blog"
        lines={[
          <>
            Guides for your <span className="font-serif italic font-medium text-brand">OSSD journey</span>
          </>,
        ]}
      />
      <section className="container-x py-16 sm:py-24" data-testid="blog-listing-section">
        {error && (
          <p className="py-16 text-center text-sm text-slate-500">Could not load posts right now — please refresh.</p>
        )}
        {!error && posts === null && <p className="py-16 text-center text-sm text-slate-500">Loading posts…</p>}
        {!error && posts !== null && posts.length === 0 && (
          <p className="py-16 text-center text-sm text-slate-500" data-testid="blog-empty-state">
            No posts yet — check back soon.
          </p>
        )}
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="blog-grid">
          {(posts || []).map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08} className="h-full">
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="card-line flex h-full flex-col p-7 transition-transform duration-200 hover:-translate-y-1"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-xs uppercase tracking-[0.18em] text-brand">{p.category}</span>
                  <span className="text-xs text-slate-400">{fmtDate(p.published_at)}</span>
                </div>
                {p.coverImage && (
                  <img src={p.coverImage} alt={p.title} loading="lazy" className="mt-4 h-40 w-full rounded-xl object-cover" />
                )}
                <h2 className="mt-4 font-display text-xl font-extrabold leading-snug text-ink">{p.title}</h2>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-slate-600">{p.excerpt}</p>
                <span className="mt-6 text-sm font-bold text-brand">Read the guide →</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
